import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { getSeenVideos } from "../../Api/authApi.js.js";
import { VideoModal } from "../VideoModal";

const MONTHS_SHORT = ['jan', 'fév', 'mar', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'];

function dateVirtuelleLabel(dateVirtuelle) {
    if (!dateVirtuelle) return '';
    const { jour_virtuel, mois_virtuel, annee_virtuelle } = dateVirtuelle;
    const mois = MONTHS_SHORT[mois_virtuel - 1] || '';
    return `${jour_virtuel} ${mois} ${annee_virtuelle}`;
}

const NotificationBell = ({ variant = 'sidebar' }) => {
    const userId = useSelector((state) => state.auth.user?.id);
    const [isOpen, setIsOpen] = useState(false);
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const containerRef = useRef(null);

    useEffect(() => {
        if (!isOpen || !userId) return;
        let cancelled = false;
        setLoading(true);
        getSeenVideos(userId, 10)
            .then((data) => { if (!cancelled) setVideos(Array.isArray(data) ? data : []); })
            .catch(() => { if (!cancelled) setVideos([]); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [isOpen, userId]);

    useEffect(() => {
        if (!isOpen) return;
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen]);

    const buttonSize = variant === 'mobile' ? 38 : 32;
    const buttonRadius = variant === 'mobile' ? 12 : 10;
    const containerStyle = variant === 'desktop-fixed'
        ? { position: 'fixed', top: 20, right: 24, zIndex: 60 }
        : { position: 'relative' };

    return (
        <div ref={containerRef} style={containerStyle}>
            <button
                id={`tuto-notification-bell-${variant}`}
                onClick={() => setIsOpen((o) => !o)}
                aria-label="Notifications"
                style={{
                    width: buttonSize, height: buttonSize, borderRadius: buttonRadius,
                    background: 'rgba(255,255,255,0.06)',
                    border: '1px solid rgba(255,255,255,0.07)',
                    display: 'grid', placeItems: 'center',
                    cursor: 'pointer', color: '#F2F5FB', padding: 0,
                    touchAction: 'manipulation',
                }}
            >
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
                    <path d="M10 2.5c-2.2 0-4 1.8-4 4v2.3c0 .6-.2 1.2-.6 1.7l-1 1.3c-.6.8 0 2 1 2h9.2c1 0 1.6-1.2 1-2l-1-1.3c-.4-.5-.6-1.1-.6-1.7V6.5c0-2.2-1.8-4-4-4z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                    <path d="M8.2 16.2a1.8 1.8 0 003.6 0" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
            </button>

            {isOpen && (
                <div style={{
                    position: 'absolute', top: 'calc(100% + 10px)', right: 0,
                    width: 300, maxHeight: 380, overflowY: 'auto',
                    background: 'linear-gradient(180deg, rgba(24,39,68,0.5) 0%, #0E1830 38%), #14213D',
                    border: '1px solid rgba(255,255,255,0.07)',
                    borderRadius: 18,
                    boxShadow: '0 20px 50px -18px rgba(0,0,0,0.7)',
                    zIndex: 200,
                    padding: 8,
                }}>
                    <div style={{
                        padding: '8px 10px 10px', fontSize: 12, fontWeight: 700,
                        letterSpacing: '0.06em', textTransform: 'uppercase', color: '#97A4BE',
                    }}>
                        Dernières actualités
                    </div>

                    {loading && (
                        <div style={{ padding: '14px 10px', fontSize: 13, color: '#97A4BE' }}>Chargement…</div>
                    )}

                    {!loading && videos.length === 0 && (
                        <div style={{ padding: '14px 10px', fontSize: 13, color: '#97A4BE' }}>Aucune vidéo vue pour l'instant.</div>
                    )}

                    {!loading && videos.map((v, index) => (
                        <button
                            key={`${v.id}_${v.video_date}_${index}`}
                            onClick={() => { setSelectedVideo(v); setIsOpen(false); }}
                            style={{
                                width: '100%', display: 'flex', flexDirection: 'column', gap: 2,
                                textAlign: 'left', padding: '10px', borderRadius: 12,
                                background: 'transparent', border: 'none', cursor: 'pointer',
                                color: '#F2F5FB',
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                        >
                            <span style={{ fontSize: 13.5, fontWeight: 600, lineHeight: 1.3 }}>{v.title}</span>
                            <span style={{ fontSize: 11.5, color: '#5C6B88' }}>{dateVirtuelleLabel(v.date_virtuelle)}</span>
                        </button>
                    ))}
                </div>
            )}

            <VideoModal video={selectedVideo} onClose={() => setSelectedVideo(null)} tagLabel={null} />
        </div>
    );
};

export default NotificationBell;
